export default {
    transform() {
        return (data) => this.transformData(JSON.parse(data))
    },

    transformData(array) {
        const itemsOnTop = array.splice(0, 2)
        const data = array.sort((a, b) => {
            return a.name.localeCompare(b.name)
        })
        const groupFirstLetter = this.groupByFirstLetter(data)
        const newStructure = {}
        const letterArray = Object.keys(groupFirstLetter)
        let charToEscape = []
        letterArray.forEach((letter, index) => {
            if (charToEscape.includes(letter)) {
                return
            }
            const currentWordsArray = groupFirstLetter[letter]
            if (currentWordsArray.length > 21 || index === letterArray.length - 1) {
                newStructure[letter] = currentWordsArray
            } else {
                let newKey = letter
                let newValue = currentWordsArray
                let nextIndex = index + 1
                let nextWordsArray = groupFirstLetter[letterArray[nextIndex]]
                while (!!nextWordsArray && newValue.length + nextWordsArray.length < 21 && nextIndex < letterArray.length) {
                    // group data
                    newKey += ` ${letterArray[nextIndex]}`
                    newValue = [...newValue, ...groupFirstLetter[letterArray[nextIndex]]]
                    // escape grouped data
                    charToEscape.push(letterArray[nextIndex])
                    // prepare next data in order to check if can be grouped
                    nextIndex += 1
                    nextWordsArray = groupFirstLetter[letterArray[nextIndex]]
                }
                newStructure[newKey] = newValue
            }
        })

        return {
            alhpabetObject: this.parseData(newStructure),
            itemsOnTop: itemsOnTop,
        }
    },

    parseData(groupFirstLetter) {
        const newStructure = {}

        Object.entries(groupFirstLetter).forEach(([letter, entries]) => {
            const entriesPerRow = Math.ceil(entries.length / 4)
            const newArrayOfEntries = []
            for (let i = 0; i < 3; i++) {
                const currentRowEntries = entries.splice(0, entriesPerRow)
                if (currentRowEntries.length > 1) {
                    const secondLastEntree = currentRowEntries[currentRowEntries.length - 2]
                    const lastEntree = currentRowEntries[currentRowEntries.length - 1]

                    if (secondLastEntree.childs?.length) {
                        const moveTwoElements = currentRowEntries.splice(currentRowEntries.length - 2, 2)
                        entries = [...moveTwoElements, ...entries]
                    } else if (lastEntree.childs?.length) {
                        const moveOneElement = currentRowEntries.splice(currentRowEntries.length - 1, 1)
                        entries = [...moveOneElement, ...entries]
                    }
                }

                newArrayOfEntries.push(currentRowEntries)
            }
            newArrayOfEntries.push(entries)
            newStructure[letter] = newArrayOfEntries
        })

        return newStructure
    },

    groupByFirstLetter(arrayData) {
        return arrayData.reduce((result, item) => {
            const firstLetter = item.name.substring(0, 1)
            item.childs = item.insurancePlans
            delete item.insurancePlans
            if (!result[firstLetter]) {
                result[firstLetter] = []
            }

            result[firstLetter].push(item)

            if (item.childs) {
                result[firstLetter].push({ id: item.id, name: 'All', allFlag: true })
                item.childs.forEach((d) => {
                    d.parentId = item.id
                    result[firstLetter].push(d)
                })
            }

            return result
        }, {})
    },
}
